module.exports = __webpack_public_path__ + "img/avatar0.64df50a8.png";